import './App.scss';
import axios from 'axios';
import { useState, useEffect, useCallback } from 'react';
import { useWizard, Wizard } from 'react-use-wizard';
import ProductTypeStep from './Steps/ProductTypeStep';
import FashionTypeStep from './Steps/FashionTypeStep';
import ClothTypeStep from './Steps/ClothTypeStep';
import ColorStep from './Steps/ColorStep';
import CountStep from './Steps/CountStep';
import DesignStep from './Steps/DesignStep';
import CheckoutStep from './Steps/CheckoutStep';
import debounce from 'lodash.debounce';
function App() {
   const [products, setProducts] = useState([]);
   const [initialState, setInitialState] = useState();
   const [isModalOpen, setIsModalOpen] = useState();
   const [editIndex, setEditIndex] = useState(null);
   const [clothingTypeStyles, setClothingTypeStyles] = useState({});

   const [productType, setProductType] = useState({});
   const [fashionType, setFashionType] = useState({});
   const [clothType, setClothType] = useState({});
   const [color, setColor] = useState({});
   const [designs, setDesigns] = useState([]);

   const logoImg = (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 69 27" height="27" width="69">
         <path
            fill="#151517"
            d="M12.5111 6.715C13.9811 6.715 15.3111 7.01833 16.5011 7.625C17.6911 8.20833 18.6244 9.11833 19.3011 10.355C20.0011 11.5917 20.3511 13.19 20.3511 15.15V26H13.7011V16.235C13.7011 14.8817 13.4211 13.9017 12.8611 13.295C12.3244 12.665 11.5661 12.35 10.5861 12.35C9.8861 12.35 9.24443 12.5133 8.6611 12.84C8.07776 13.1433 7.62276 13.6217 7.2961 14.275C6.96943 14.9283 6.8061 15.78 6.8061 16.83V26H0.156095V0.0299985H6.8061V12.42L5.2661 10.845C5.98943 9.46833 6.9811 8.44167 8.2411 7.765C9.5011 7.065 10.9244 6.715 12.5111 6.715ZM33.9355 26.315C31.8588 26.315 30.0155 25.895 28.4055 25.055C26.7955 24.215 25.5238 23.06 24.5905 21.59C23.6805 20.0967 23.2255 18.3933 23.2255 16.48C23.2255 14.5667 23.6805 12.875 24.5905 11.405C25.5238 9.935 26.7955 8.79167 28.4055 7.975C30.0155 7.135 31.8588 6.715 33.9355 6.715C36.0121 6.715 37.8555 7.135 39.4655 7.975C41.0988 8.79167 42.3705 9.935 43.2805 11.405C44.1905 12.875 44.6455 14.5667 44.6455 16.48C44.6455 18.3933 44.1905 20.0967 43.2805 21.59C42.3705 23.06 41.0988 24.215 39.4655 25.055C37.8555 25.895 36.0121 26.315 33.9355 26.315ZM33.9355 21.03C34.7055 21.03 35.3821 20.855 35.9655 20.505C36.5721 20.155 37.0505 19.6417 37.4005 18.965C37.7505 18.265 37.9255 17.4367 37.9255 16.48C37.9255 15.5233 37.7505 14.7183 37.4005 14.065C37.0505 13.3883 36.5721 12.875 35.9655 12.525C35.3821 12.175 34.7055 12 33.9355 12C33.1888 12 32.5121 12.175 31.9055 12.525C31.3221 12.875 30.8438 13.3883 30.4705 14.065C30.1205 14.7183 29.9455 15.5233 29.9455 16.48C29.9455 17.4367 30.1205 18.265 30.4705 18.965C30.8438 19.6417 31.3221 20.155 31.9055 20.505C32.5121 20.855 33.1888 21.03 33.9355 21.03ZM47.376 26V7.03H53.711V12.56L52.766 10.985C53.326 9.56167 54.236 8.5 55.496 7.8C56.756 7.07667 58.2844 6.715 60.081 6.715V12.7C59.7777 12.6533 59.5094 12.63 59.276 12.63C59.066 12.6067 58.8327 12.595 58.576 12.595C57.2227 12.595 56.126 12.9683 55.286 13.715C54.446 14.4383 54.026 15.6283 54.026 17.285V26H47.376ZM65.0018 26.315C63.8818 26.315 62.9368 25.9417 62.1668 25.195C61.3968 24.4483 61.0118 23.5033 61.0118 22.36C61.0118 21.17 61.3968 20.225 62.1668 19.525C62.9368 18.8017 63.8818 18.44 65.0018 18.44C66.1218 18.44 67.0668 18.8017 67.8368 19.525C68.6068 20.225 68.9918 21.17 68.9918 22.36C68.9918 23.5033 68.6068 24.4483 67.8368 25.195C67.0668 25.9417 66.1218 26.315 65.0018 26.315Z"
         />
      </svg>
   );

   useEffect(() => {
      fetchInitialData();
   }, []);

   const handleLogoClick = () => {
      if (products.length || designs.length || productType.name) {
         showModal();
      } else {
         window.location.href = 'https://hor.clothing';
      }
   };

   const showModal = () => {
      document.body.classList.add('hidden');
      setIsModalOpen(true);
   };
   const handleCloseModal = () => {
      document.body.classList.remove('hidden');
      setIsModalOpen(false);
   };

   const fetchInitialData = () => {
      axios({ url: '/initial-state', method: 'GET' }).then(response => {
         setInitialState(response.data);
      });
   };
   const fetchClothingTypeStyles = type => {
      setFashionType(type);
      axios({ url: `/clothing-type-styles/${type.id}/details`, method: 'GET' }).then(response => {
         setClothingTypeStyles(response.data);
      });
   };
   const handleChangeProductType = productType => {
      setProductType(productType);
   };
   const handleChangeClothType = clothType => {
      setClothType(clothType);
   };
   const handleChangeColor = color => {
      setColor(color);
   };

   const handleChangeDesignQuantity = useCallback(
      async (index, designId, value) => {
         const productsCopy = [...products];
         const decorationIndex = productsCopy[index].decorations.findIndex(item => item.group_id === designId);
         if (+value === 0) {
            productsCopy[index].decorations = productsCopy[index].decorations.filter(
               item => item.group_id !== designId,
            );
         } else if (decorationIndex !== null && decorationIndex !== -1) {
            productsCopy[index].decorations[decorationIndex].quantity = +value;
         } else {
            productsCopy[index].decorations.push({
               group_id: designId,
               quantity: +value,
            });
         }

         await setProducts(productsCopy);
         debouncedSave(index);
      },
      [products, designs],
   );

   const debouncedSave = useCallback(
      debounce(index => {
         calculateTotalPrice(index);
      }, 500),
      [products, designs],
   );

   const handleCountChange = useCallback(
      (index, indexSize, value) => {
         const productsCopy = [...products];
         productsCopy[index].sizes[indexSize].quantity = +value;
         setProducts(productsCopy);
         debouncedSave(index);
      },
      [products, designs],
   );

   const isValidProduct = item => {
      return item.sizes.length && item.sizes.some(size => size.quantity > 0);
   };

   const calculateTotalPrice = useCallback(
      async index => {
         const productsCopy = [...products];
         if (!isValidProduct(productsCopy[index])) {
            productsCopy[index].clothes_price = 0;
            productsCopy[index].decorations_price = 0;
            productsCopy[index].total_price = 0;
            productsCopy[index].quantity = 0;
            setProducts(productsCopy);
            return;
         }
         const totalQuantity = productsCopy[index].sizes
            .filter(size => size.quantity > 0)
            .reduce((acc, size) => acc + size.quantity, 0);
         productsCopy[index].quantity = +totalQuantity;
         const totalDecorationsQuantity = productsCopy[index].decorations
            .filter(item => item.group_id !== 0)
            .reduce((acc, item) => acc + item.quantity, 0);
         productsCopy[index].decorations[0].quantity = totalQuantity - totalDecorationsQuantity;

         await axios({ url: `/orders/calculate`, method: 'POST', data: prepareData([productsCopy[index]]) })
            .then(response => {
               productsCopy[index].clothes_price = response.data.clothes_price;
               productsCopy[index].decorations_price = response.data.decorations_price;
               productsCopy[index].total_price = response.data.total_price;
               productsCopy[index].error = null;
               setProducts(productsCopy);
            })
            .catch(error => {
               const errors = error.response.data.errors;
               Object.keys(errors).forEach(key => {
                  productsCopy[index].error = errors[key];
                  setProducts(productsCopy);
               });
            });
      },
      [products, designs],
   );

   const prepareDecorationsGroup = useCallback(() => {
      return designs.map(design => {
         return {
            id: design.id,
            name: design.name,
            decorations: design.value.map(item => item.size).filter(Boolean),
         };
      });
   }, [designs]);
   const prepareData = productItems => {
      const items = [...productItems].map(product => {
         let decorations;
         const zeroGroup = product.decorations.find(item => item.group_id === 0);
         const totalDecorationsQuantity = product.decorations
            .filter(item => item.group_id !== 0)
            .reduce((acc, item) => acc + item.quantity, 0);

         if (totalDecorationsQuantity === product.quantity) {
            decorations = product.decorations.filter(item => item.group_id !== 0);
         } else {
            if (zeroGroup.quantity < 0) {
               decorations = [{ group_id: 0, quantity: 0 }, ...product.decorations.filter(item => item.group_id !== 0)];
            } else {
               decorations = product.decorations;
            }
         }

         return {
            item_id: product.item_id,
            color_id: product.color_id,
            quantity: product.quantity,
            sizes: product.sizes
               .filter(item => item.quantity > 0)
               .map(item => ({ size_id: item.id, quantity: item.quantity })),
            decorations,
         };
      });
      return { items, decoration_groups: prepareDecorationsGroup() };
   };

   const onSubmitProduct = () => {
      const product = {
         data: { productType, fashionType, clothType, color },
         item_id: clothType.item_id,
         color_id: color.id,
         quantity: 0,
         sizes: clothingTypeStyles.sizes.map(size => ({ ...size, quantity: '' })),
         decorations_price: 0,
         total_price: 0,
         clothes_price: 0,
         decorations: [
            {
               group_id: 0,
               quantity: 0,
            },
         ],
      };

      if (editIndex || editIndex === 0) {
         const productsCopy = [...products];
         productsCopy[editIndex] = product;
         setClothingTypeStyles({});
         setProducts(productsCopy);
         setEditIndex(null);
      } else {
         setClothingTypeStyles({});
         setProducts([...products, product]);
      }

      setClothType({});
      setColor({});
      setProductType({});
      setFashionType({});
      setClothingTypeStyles({});
   };

   const handleEditProduct = (index, goToStep) => {
      setEditIndex(index);
      const product = products[index];
      setProductType(product.data.productType);
      fetchClothingTypeStyles(product.data.fashionType);
      setClothType(product.data.clothType);
      setColor(product.data.color);
      goToStep(0);
   };
   const handleDeleteProduct = index => {
      const productsCopy = [...products];
      productsCopy.splice(index, 1);
      setProducts(productsCopy);
   };
   const handleAddNewProduct = goToStep => {
      goToStep(0);
   };
   const handleCreateDesign = goToStep => {
      goToStep(5);
   };
   const handleSaveDesigns = designs => {
      setDesigns(designs);
   };

   const handleCalculateProductsOnInit = () => {
      products.forEach((product, index) => {
         if (product.sizes.length > 0 && product.quantity) {
            calculateTotalPrice(index);
         }
      });
   };
   const handleDeleteDesign = async (index, designsItems) => {
      const designsCopy = [...designs];
      const deletedDesign = designsCopy[index];
      await setDesigns(designsItems);

      const productsCopy = products.map(product => {
         return { ...product, decorations: product.decorations.filter(item => item.group_id !== deletedDesign.id) };
      });
      await setProducts(productsCopy);
   };

   const Header = () => {
      const { goToStep, activeStep } = useWizard();
      return activeStep < 6 ? (
         <div className={`step__container hor-app__head`}>
            <div className="hor-app__tabs">
               <div className={`hor-app__tab ${activeStep === 4 ? 'active' : ''}`} onClick={() => goToStep(4)}>
                  список товарів
               </div>
               <div className={`hor-app__tab ${activeStep === 5 ? 'active' : ''}`} onClick={() => goToStep(5)}>
                  дизайн
               </div>
            </div>
            <div className={`hor-app__breadcrumbs ${activeStep >= 4 && 'hidden'}`}>
               <div className={`hor-app__breadcrumb ${activeStep === 0 ? 'active' : ''}`} onClick={() => goToStep(0)}>
                  товар >
               </div>
               <div
                  className={`hor-app__breadcrumb  ${activeStep === 1 ? 'active' : ''} ${
                     activeStep < 1 && editIndex === null && 'disabled'
                  }`}
                  onClick={() => goToStep(1)}
               >
                  фасон >
               </div>
               <div
                  className={`hor-app__breadcrumb  ${activeStep === 2 ? 'active' : ''} ${
                     activeStep < 2 && editIndex === null && 'disabled'
                  }`}
                  onClick={() => goToStep(2)}
               >
                  матеріал >
               </div>
               <div
                  className={`hor-app__breadcrumb  ${activeStep === 3 ? 'active' : ''} ${
                     activeStep < 3 && editIndex === null && 'disabled'
                  }`}
                  onClick={() => goToStep(3)}
               >
                  колір
               </div>
            </div>
         </div>
      ) : (
         ''
      );
   };
   return (
      <div className="hor-app">
         <div className="hor-app__header">
            <div className="hor-app__header-logo" onClick={handleLogoClick}>
               {logoImg}
            </div>
         </div>
         {initialState && (
            <Wizard header={<Header />}>
               <ProductTypeStep
                  items={initialState.clothing_types}
                  value={productType}
                  handleChangeForm={handleChangeProductType}
               />
               <FashionTypeStep
                  items={productType.styles}
                  value={fashionType}
                  handleChangeFashionType={fetchClothingTypeStyles}
               />
               <ClothTypeStep
                  items={clothingTypeStyles.materials}
                  value={clothType}
                  handleChangeClothType={handleChangeClothType}
               />
               <ColorStep
                  items={clothType.colors}
                  value={color}
                  handleChangeColor={handleChangeColor}
                  onSubmitProduct={onSubmitProduct}
               />
               <CountStep
                  products={products}
                  designs={designs}
                  handleCountChange={handleCountChange}
                  handleChangeDesignQuantity={handleChangeDesignQuantity}
                  handleEditProduct={handleEditProduct}
                  handleDeleteProduct={handleDeleteProduct}
                  handleAddNewProduct={handleAddNewProduct}
                  handleCreateDesign={handleCreateDesign}
                  handleCalculateProductsOnInit={handleCalculateProductsOnInit}
               />
               <DesignStep
                  placements={initialState.decoration_placements}
                  values={designs}
                  handleSaveDesigns={handleSaveDesigns}
                  handleDeleteDesign={handleDeleteDesign}
               />
               <CheckoutStep products={products} designs={designs} />
            </Wizard>
         )}
         {isModalOpen && (
            <div>
               <div className="step__modal step__modal--leave">
                  <div className="step__modal-leave">
                     <div className="step__modal-leave-img">
                        <svg width="100" height="98" viewBox="0 0 100 98" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                           <g clipPath="url(#clip0_2716_1789)">
                              <path
                                 d="M44.3443 46.1591C46.2654 46.1199 48.1956 46.2457 50.1045 46.0977C50.7699 46.0464 51.7025 45.538 51.9717 44.9814C53.1918 42.4557 54.1783 39.8203 55.3384 37.2644C55.6696 36.5356 56.0851 35.7847 56.8206 35.3468C59.8227 34.3129 62.8531 33.0808 65.9689 32.7194C69.7776 32.2755 73.6817 32.5795 77.5411 32.6731C78.3823 32.6932 79.4175 32.9721 80.0098 33.5106C82.3596 35.6518 85.3616 38.7311 87.5763 41.0122C88.7283 42.199 88.7405 44.2395 87.7571 45.2753C86.5309 46.5668 84.6494 46.6856 83.2282 45.4062C81.5367 43.8821 79.1605 40.837 77.5035 39.2737C77.087 38.8801 76.5506 38.3667 76.0508 38.3446C73.4541 38.3446 71.4061 38.6093 68.9699 38.868C69.8771 41.5125 70.7813 43.9012 71.5148 46.3393C73.319 52.3339 74.8185 58.4362 79.6928 62.9792C80.5614 63.7895 81.2878 64.2345 82.4693 64.2224C87.1161 64.1711 91.7618 64.2184 96.4086 64.1892C97.8827 64.1791 99.0368 64.6824 99.6361 66.0293C100.229 67.3621 100.145 68.3778 99.0154 69.2335C98.0889 69.9341 96.818 70.527 95.6822 70.5612C90.6179 70.7102 85.5455 70.5874 80.4781 70.678C78.4971 70.7132 76.9133 70.4948 75.6973 68.8942C73.8676 66.4833 71.8449 64.2174 70.4115 62.498C67.5852 64.9693 64.824 67.2856 62.2029 69.7479C61.6005 70.3136 61.2023 71.3746 61.1799 72.2192C61.0702 76.4622 61.1301 80.7082 61.1027 84.9533C61.0885 87.179 59.8155 88.4544 57.6598 88.4836C55.7164 88.5087 54.4963 87.181 54.4871 84.9382C54.4637 79.7358 54.4201 74.5335 54.5125 69.3331C54.5288 68.4131 54.9626 67.347 55.5447 66.6162C57.5988 64.0392 59.8166 61.589 61.9337 59.0593C62.2852 58.6385 62.7617 57.955 62.6377 57.5614C61.4258 53.7201 60.098 49.9139 58.6503 45.6488C58.2856 46.6756 58.1362 47.3067 57.8477 47.8664C56.8552 49.7931 56.5657 52.3842 53.4763 52.353C50.4011 52.3218 47.3239 52.4356 44.2498 52.3651C42.2342 52.3188 41.0141 51.0021 41.0598 49.2053C41.1076 47.3711 42.3328 46.2034 44.3443 46.1622V46.1591Z"
                                 fill="#231F20" />
                              <path
                                 d="M50.4866 26.2805C50.5171 22.721 53.3626 19.9809 56.9996 20.006C60.6314 20.0332 63.3419 22.7934 63.3175 26.4395C63.2931 30.0493 60.5085 32.7562 56.8431 32.729C53.2702 32.7029 50.4561 29.849 50.4866 26.2794V26.2805Z"
                                 fill="#231F20" />
                              <path
                                 d="M66.4484 85.4685H66.4434C66.4464 85.4071 66.4464 85.3437 66.4484 85.2812V85.4685Z"
                                 fill="#231F20" />
                              <path
                                 d="M66.4476 0V19.4635C64.9064 17.3455 62.6623 15.7832 60.024 15.0936V6.36502H6.42359V8.45985L37.0045 23.0623V97.5712V98L0 80.2538V0H66.4476Z"
                                 fill="#231F20" />
                           </g>
                           <defs>
                              <clipPath id="clip0_2716_1789">
                                 <rect width="100" height="98" fill="white" />
                              </clipPath>
                           </defs>
                        </svg>
                     </div>
                     <div className="step__modal-leave-content">
                        <p className="step__modal-leave-content-description">
                           Ви впевнені, що хочете покинути сторінку?<br/>
                           Ваші зміни будуть втрачені
                        </p>
                        <div className="step__modal-leave-actions">
                           <button className="step__modal-leave-actions-btn" onClick={handleCloseModal}>
                              залишитися
                           </button>
                           <a href="https://hor.clothing" className="step__modal-leave-actions-btn step__modal-leave-actions-btn--sub">
                              покинути
                           </a>
                        </div>
                     </div>

                  </div>
               </div>
               <div className="step__modal-overlay" onClick={handleCloseModal}></div>
            </div>
         )}
      </div>
   );
}

export default App;
